<template>
<div>
  <!-- <v-btn @click="refresh" fab fixed bottom left>
    {{unauthorizedRequestCount}}|{{loginChallengeCount}}
  </v-btn> -->
  <v-dialog persistent v-model="loginchallenge"
    overlay-opacity="90"
    width="360px" >
    <v-card>
      <login
        v-if="loginchallenge"
        :with-init="false"
        @loggedin="loginchallenge=false;$emit('loggedin')" />
    </v-card>
  </v-dialog>
</div>

</template>

<script>
import {mapGetters} from 'vuex'
import Login from '@/components/pages/Login.vue'

export default {
  name: 'Session',
  components: {Login},
  data () {
    return {
      refreshtype: 'ping',
      loginchallenge: false,
      logoutDialog: false,
      requests: {
        refresh: {
          resource: 'ag.auth.session',
          method: 'post',
          status: 0
        }
      },
      heartbeatIntervalTime: 600000,
      // heartbeatIntervalTime: 10000,
      heartbeatInterval: null
    }
  },
  watch: {
    loginChallengeCount () {
      if (['/login', '/logout'].indexOf(this.$route.path) === -1) {
        this.$store.commit('SET_POST_LOGIN_REDIRECT', this.$route.path)
        this.refreshtype = '401'
        this.loginchallenge = true
      }
      // this.refresh()
    },
    logoutRequestCount () {
      this.logout()
    },
    unauthorizedRequestCount () {
      if (this.unauthorizedRequestCount > 0) {
        this.$store.commit('LOGIN_CHALLENGE')
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'loginChallengeCount',
      'logoutRequestCount'
    ]),
    unauthorizedRequestCount () {
      return (this.$store.getters.getRequestByStatusCode(401).length)
    },
    logoutStatus () {
      return this.requests.logout.status
    }
  },
  methods: {
    logout () {
      this.$router.push({path: '/logout'})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Session.vue?9f56ab4c